
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontact } from '../../api/contact.api'

import './inicio.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pinicio = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id64afda918b8ac2e1bb827064" >

      <div id="i55h" className="">
      
      <div id="icv7c" className="">
      
      <div id="iigln" className="">
      
      <img
        className=""
        id="ih3ya"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk11rnk9.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ik5bn"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk11skmt.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ivz5n" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Home</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>About</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Team</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Contact</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Twitter</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="icm2ph"
        src="https://assetsprojects.s3.amazonaws.com/405gznilk1i8ejy.png"
        alt="undefined"
      />
      
      <div id="ieynp" className="gjs-row ">
      
      <div id="ipzu4" className="gjs-cell ">
      
      <div className="" id="idt3r">
        <>Somos</>
      <br className="" id="" />
      
      <b className="" id="">
        <>TU TESORERÍA</>
      <br className="" id="" />
      
      </b>
      <>del FUTURO</>
      </div>
      
      <div id="io1sl" className="">
      
      </div>
      
      <div id="if42j" className="">
      
        <a
          target=""
          className=""
          id="i6bns"
          href="#"
        >
          
    <div id="iz9oi" className="">
    <>COTIZA EN TIEMPO REAL</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="iwhzj" className="gjs-cell ">
      
      <img
        className=""
        id="i7t64"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk123i4p.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ie7i" className="">
      
      <div id="ikgn" className="">
      
      <div id="iju15" className="">
      
      <div id="irx7i" className="">
      
      <div id="ii5v3" className="">
      
      <img
        className=""
        id="i5xhw"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk12bkfl.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div className="" id="itjm8">
        <>Gestión Inteligente</>
      </div>
      
      <div className="" id="ip277">
        <>Logra tener el control de tu liquidez sin puntos ciegos y con data de tu comportamiento, y el del mercado financiero, fácil de analizar</>
      </div>
      
      </div>
      
      <div id="ivvrqh" className="">
      
      <div id="im7f4" className="">
      
      <div id="if84z" className="">
      
      <img
        className=""
        id="iksr9"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk12fyml.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div className="" id="icetg">
        <>Aprende mientras haces</>
      </div>
      
      <div className="" id="ibb26r">
        <>Sabemos que la mejor</>
      <br className="" id="" />
      <>forma de aprender es con</>
      <br className="" id="" />
      <>acompañamiento y </>
      <br className="" id="" />
      <>ejecución simultanea</>
      </div>
      
      </div>
      
      <div id="i9ysw" className="">
      
      <div id="icrpu" className="">
      
      <div id="i1enk" className="">
      
      <img
        className=""
        id="iw6jk"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk12g8l1.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div className="" id="iei1l">
        <>Soporte 24/7</>
      </div>
      
      <div className="" id="i28q8">
        <>Logra tener el control de tu liquidez sin puntos ciegos y con data de tu comportamiento, y el del mercado financiero, fácil de analizar</>
      </div>
      
      </div>
      
      </div>
      
      <div id="icm6cf" className="gjs-row ">
      
      <div id="i3kv92" className="gjs-cell ">
      
      </div>
      
      <div id="i3x0ad" className="gjs-cell ">
      
      <div className="" id="io8thq">
        <>¿Sabías que los recursos de tu empresa pueden estar perdiendo valor en este momento?</>
      </div>
      
      <div className="" id="ixcyot">
        <>Conoce el potencial que tiene</>
      <br className="" id="" />
      <>los recursos de tu empresa</>
      </div>
      
        <a
          target=""
          className=""
          id="i9pm15"
          href="#"
        >
          
    <div id="i0rb6y" className="">
    <>COTIZA EN TIEMPO REAL</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ih3j" className="">
      
      <div id="ilb3e4" className="gjs-row ">
      
      <div id="igpwko" className="gjs-cell ">
      
      <div className="" id="iilxvb">
        <>¿Administras tus recursos únicamente en </>
      <br className="" id="" />
      <>instrumentos a la vista? </>
      </div>
      
      <div className="" id="i6altf">
        <>Conoce el potencial que tiene</>
      <br className="" id="" />
      <>los recursos de tu empresa</>
      </div>
      
      <div id="i79kaf" className="">
      
        <a
          target=""
          className=""
          id="i4rkbi"
          href="#"
        >
          
    <div id="isogzr" className="">
    <>Si únicamente a la vista</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="imbntg"
          href="#"
        >
          
    <div id="i0ofd3" className="">
    <>También en CTDs</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ig18uk" className="gjs-cell ">
      
      <div id="ib3qne" className="">
      
      <img
        className=""
        id="izjrpi"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk12zwiu.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i8x7l" className="">
      
      <div id="ihylc8" className="">
      
      <div className="" id="iwhbej">
        <>¿Cuál es el valor de los recursos</>
      <br className="" id="" />
      <>que tienes invertidos?</>
      </div>
      
      <div id="ioaqgy" className="">
      
        <div id="undefined" className="inputContainer ">
          
      <input
        name=""
        type="text"
        placeholder=""
        className="formInput "
        id=""
      />
      
        </div>
      
      <div className="" id="i8uyxd">
        <>Millones</>
      </div>
      
        <a
          target=""
          className=""
          id="i7lpq4"
          href="#"
        >
          
    <div id="i1ii5h" className="">
    <>SIMULAR</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="iyaic" className="">
      
      <div id="i68hp6" className="gjs-row ">
      
      <div id="iav115" className="gjs-cell ">
      
      <img
        className=""
        id="i84n26"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk13cngw.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i4mxy7" className="gjs-cell ">
      
      <div className="" id="ioh5ti">
        <>Ganancia Total</>
      </div>
      
      <div id="ibg3yq" className="">
      
      <img
        className=""
        id="iowgsn"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk13eg5p.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iu4pxb" className="">
      
      <img
        className=""
        id="ial8cf"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk13f0s8.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i94g6d" className="">
      
      <img
        className=""
        id="iub0y4"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk13eg5p.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ijn4q" className="">
      
      <div className="" id="io4ip2">
        <>¿Quieres conocer cómo puedes conseguir que tus</>
      <br className="" id="" />
      <>recursos lleguen al máximo de su potencial? </>
      </div>
      
        <div className="" id="icbglp">
          
      <form
        id="is002f"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontact({
						token: 'aasdas',
				nombre: e.target.nombre.value,
						empresa: e.target.empresa.value,
						telefono: e.target.telefono.value,
						correo: e.target.correo.value,
					});
					alert("Se envió exitosamente la información");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="ij9nul" className="">
      
      <label id="ihdlid" className="">
      <>Nombre:</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombre"
        type="text"
        placeholder=""
        className=""
        id="inzr6s"
      />
      
      </div>
      
      <div id="i62lny" className="">
      
      <label id="imp4u3" className="">
      <>Empresa:</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="empresa"
        type="text"
        placeholder=""
        className=""
        id="iiic3j"
      />
      
      </div>
      
      <div id="im6ilb" className="">
      
      <label id="ijj15h" className="">
      <>Teléfono:</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telefono"
        type="text"
        placeholder=""
        className=""
        id="ihkf52"
      />
      
      </div>
      
      <div id="irc4ec" className="">
      
      <label id="idzwl7" className="">
      <>E-Mail:</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correo"
        type="text"
        placeholder=""
        className=""
        id="i120ad"
      />
      
      </div>
      
      <div id="iqdav3" className="">
      
      <button
        type="submit"
        name=""
        id="i47zps"
        className=""
        
      >
      <>Enviar</>
      </button>
      
      </div>
      
      </form>
      
        </div>
        
      <div id="io0gfm" className="">
      
      <img
        className=""
        id="i0uegp"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk144czy.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i5of" className="">
      
      <div id="i8lmjf" className="">
      
      <div id="im4a28" className="">
      
      <img
        className=""
        id="iteqmg"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk11rnk9.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iqpkke" className="">
      
      <div className="" id="iy8adh">
        <>Dirección</>
      </div>
      
      <div className="" id="iiauur">
        <>Ciudad de Bogota, Colombia</>
      </div>
      
      </div>
      
      <div id="imh7h6" className="">
      
      <div className="" id="ijoril">
        <>Correo de contacto</>
      </div>
      
      <div className="" id="ik2c1u">
        <>info@reasurytools.com.co</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iw4n9w" className="">
      
      <div id="ianz3m" className="">
      
      </div>
      
      <div id="iufalf" className="">
      
      <div className="" id="ij1xap">
        <>Coyright©2023 Treasury Tool - Todos los derechos reservados.</>
      </div>
      
      <div id="ielirh" className="">
      
      <img
        className=""
        id="ii3z3k"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14hfve.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i1414e"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14i6xh.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="it3ooa"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14iokp.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinicio);
  